// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

export enum PackageName {
  Credential = 'dtc-credential',
  Registry = 'dtc-registry',
  RegistryApp = 'dtc-registry-app',
  RegistryHolding = 'dtc-registry-holding',
  Splice = 'splice-amulet',
}
